      // YouTube needs an HTTP(S) page origin. Direct file:// previews keep the
      // poster until another source is selected so the player avoids error 153.
      (function mountYouTubePlayers() {
        const hasWebOrigin = /^https?:$/.test(window.location.protocol);

        document.querySelectorAll('[data-youtube-id]').forEach(function(mount) {
          const youtubeId = mount.getAttribute('data-youtube-id');
          const tencentId = mount.getAttribute('data-tencent-id');
          const title = mount.getAttribute('data-youtube-title') || 'YouTube video';
          const controls = mount.closest('.dze-product__recording-media')?.querySelectorAll('[data-video-source]') || [];
          if (!youtubeId && !tencentId) return;

          const selectSource = function(source) {
            const isTencent = Boolean(tencentId && (source === 'tencent' || !youtubeId));
            const iframe = document.createElement('iframe');
            iframe.src = isTencent
              ? `https://v.qq.com/txp/iframe/player.html?vid=${encodeURIComponent(tencentId)}`
              : `https://www.youtube-nocookie.com/embed/${encodeURIComponent(youtubeId)}?rel=0`;
            iframe.title = isTencent ? `${title} — 腾讯视频` : title;
            iframe.loading = 'lazy';
            iframe.referrerPolicy = 'strict-origin-when-cross-origin';
            iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
            iframe.setAttribute('allowfullscreen', '');
            mount.replaceChildren(iframe);

            controls.forEach(function(button) {
              const isActive = button.getAttribute('data-video-source') === (isTencent ? 'tencent' : 'youtube');
              button.classList.toggle('is-active', isActive);
              button.setAttribute('aria-pressed', String(isActive));
            });
          };

          controls.forEach(function(button) {
            button.addEventListener('click', function() {
              selectSource(button.getAttribute('data-video-source'));
            });
          });

          if (hasWebOrigin) selectSource(youtubeId ? 'youtube' : 'tencent');
        });
      })();

      // Save an application email as a Shopify email subscriber only when the
      // optional marketing consent checkbox is selected. The application itself
      // continues through Shopify's native contact form even if opt-in fails.
      (function bindApplicationMarketingConsent() {
        document.querySelectorAll('[data-dze-application-form]').forEach(function(section) {
          const applicationForm = section.querySelector('form.guanyin-form');
          const marketingForm = section.querySelector('form.guanyin-marketing-form');
          const consent = applicationForm?.querySelector('[data-dze-marketing-consent]');
          const applicationEmail = applicationForm?.querySelector('[data-dze-application-email]');
          const marketingEmail = marketingForm?.querySelector('[data-dze-marketing-email]');
          const submit = applicationForm?.querySelector('[type="submit"]');
          let resubmitting = false;
          let pending = false;
          const subscriptionStatusKey = `dze-application-subscription:${window.location.pathname}`;

          if (section.querySelector('[data-dze-application-success]')) {
            try {
              if (sessionStorage.getItem(subscriptionStatusKey) === 'failed') {
                const status = document.createElement('p');
                status.className = 'form-status';
                status.setAttribute('role', 'status');
                status.textContent = 'Your application was submitted, but your newsletter subscription could not be saved. Please use the newsletter form to subscribe.';
                section.querySelector('[data-dze-application-success]').after(status);
              }
              sessionStorage.removeItem(subscriptionStatusKey);
            } catch (error) {}
          }

          if (!applicationForm || !marketingForm || !consent || !applicationEmail || !marketingEmail || !submit) return;

          applicationForm.addEventListener('submit', async function(event) {
            if (resubmitting || !consent.checked) return;
            event.preventDefault();
            if (pending || !applicationForm.reportValidity()) return;
            pending = true;

            marketingEmail.value = applicationEmail.value.trim();
            submit.disabled = true;

            try {
              const response = await fetch(marketingForm.action, {
                method: 'POST',
                body: new FormData(marketingForm),
                credentials: 'same-origin',
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                signal: AbortSignal.timeout(10000)
              });
              const responseHtml = await response.text();
              const responseDocument = new DOMParser().parseFromString(responseHtml, 'text/html');
              const returnedResult = responseDocument.querySelector('.guanyin-marketing-form [data-dze-marketing-result]');
              const responseUrl = new URL(response.url, window.location.origin);
              const subscribed = responseUrl.searchParams.get('customer_posted') === 'true' || returnedResult?.dataset.success === 'true';
              if (!response.ok || !subscribed) throw new Error('Email subscription failed');

              try { sessionStorage.removeItem(subscriptionStatusKey); } catch (error) {}
            } catch (error) {
              try { sessionStorage.setItem(subscriptionStatusKey, 'failed'); } catch (storageError) {}
            }

            resubmitting = true;
            pending = false;
            submit.disabled = false;
            applicationForm.requestSubmit(submit);
          });
        });
      })();

      $(function() {
        const $section = $('[data-dze-index]');
        const $stage = $('.dze-index__stage');
        const $menuTriggers = $('[data-dze-menu-trigger]');
        const $menuPanels = $('[data-dze-menu-panel]');
        const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        const isCompact = $section.is('[data-dze-index-compact]');
        
        let ticking = false;
        let activeMenu = null;
        let pendingMenu = null;

        const $menuOverlay = $('<div class="dze-menu-overlay"></div>').appendTo($stage);
        $menuOverlay.on('click', () => setMenu(null));

        const mix = (start, end, amount) => start + (end - start) * amount;

        const setMenu = (menu) => {
          activeMenu = menu;
          $stage.toggleClass('is-menu-open', Boolean(menu));
          if (menu) {
            $menuOverlay.addClass('is-active');
          } else {
            $menuOverlay.removeClass('is-active');
          }
          $menuPanels.each(function() {
            $(this).prop('hidden', $(this).attr('data-dze-menu-panel') !== menu);
          });
          $menuTriggers.each(function() {
            $(this).attr('aria-expanded', String($(this).attr('data-dze-menu-trigger') === menu));
          });
        };

        const update = () => {
          ticking = false;
          const rectTop = $section[0].getBoundingClientRect().top;
          const stageWidth = $stage.outerWidth();
          const stageHeight = $stage.outerHeight();
          const distance = Math.max($(window).height() * 0.82, 1);
          
          const rawProgress = isCompact ? 1 : Math.min(Math.max(-rectTop / distance, 0), 1);
          const progress = motionQuery.matches ? 1 : rawProgress;
          
          if (progress > 0.95) {
            $section.addClass('is-scrolled');
            // 当滚动完成时，确保没有多余的跳跃（紧凑模式下不需要锁定）
            if (!isCompact && !ticking && window.scrollY < distance && !motionQuery.matches) {
              window.scrollTo({ top: distance, behavior: 'instant' });
            }
          } else {
            $section.removeClass('is-scrolled');
          }

          const eased = 1 - Math.pow(1 - progress, 3);
          const viewportWidth = $(window).width() || stageWidth;
          const textScale = Math.min(stageWidth / 2560, 1);
          const isMobile = viewportWidth <= 749;
          const compactNav = viewportWidth <= 749
            ? { size: 20, top: 16, side: 16 }
            : viewportWidth < 1440
              ? { size: 20, top: 18, side: 16 }
              : viewportWidth <= 1920
                ? { size: 22, top: 20, side: 24 }
                : { size: 36, top: 30, side: 40 };

          const navEnd = compactNav.size;
          const navStart = isCompact ? navEnd : (isMobile ? 24 : getOpenNavSize(viewportWidth));

          // The homepage animation now lands on the same header geometry as compact pages.
          const navTopStart = isMobile ? 20 : 40;
          const navSideStart = isMobile ? 16 : 40;
          const navTop = isCompact ? compactNav.top : mix(navTopStart, compactNav.top, eased);
          const navSide = isCompact ? compactNav.side : mix(navSideStart, compactNav.side, eased);
          const navRight = navSide;
          const utilityRight = navSide;
          
          // Pure font-size transition based on scroll, no scaling transformation
          const navSize = mix(navStart, navEnd, eased);
          const navLetterSpacing = mix(isMobile ? -0.05 : -0.05, -0.05, eased); // Keep letter spacing constant for standard a tags
          
          const imageScale = textScale;
          // 移动端图片调整
          const imageHeight = isMobile ? viewportWidth * (600/360) : 960 * imageScale;
          const mediaWidth = isMobile ? viewportWidth - 32 : 640 * imageScale;

          // 小字体状态下，图片距离毛玻璃导航栏（PC 120px / 移动端 70px）下方 40px
          const imageEndTop = isMobile ? 110 : 160;
          // 大字体状态下，图片距离顶部大字体菜单下方 40px
          const imageStartTop = isMobile ? imageEndTop : navTop + navStart + 40;
          const mediaTop = mix(imageStartTop, imageEndTop, eased);
          const captionTop = mediaTop + imageHeight + 20;
          const introTop = captionTop + 28 * imageScale;
          const introOpacity = Math.min(Math.max((progress - 0.72) / 0.18, 0), 1);

          const captionEndTop = imageEndTop + imageHeight + 20;
          const introEndTop = captionEndTop + 28 * imageScale;
          const $intro = $('.dze-index__intro');
          // .outerHeight(true) includes the margin-top and margin-bottom
          const introHeight = $intro.outerHeight(true) || 192;
          const finalStageHeight = introEndTop + introHeight - 25;

          // Apply to $section so it cascades to both .dze-index and its children
          $section[0].style.setProperty('--dze-stage-min-height', `${finalStageHeight}px`);
          
          // Fallback: directly set height on sticky and stage to avoid CSS variable cascade bugs
          if (!isCompact) {
            $('.dze-index__sticky').css('height', `${finalStageHeight}px`);
            $('.dze-index__stage').css('height', `${finalStageHeight}px`);
          }

          $stage.css({
            '--dze-nav-size': `${navSize}px`,
            '--dze-nav-letter-spacing': `${navLetterSpacing}rem`,
            '--dze-nav-top': `${navTop}px`,
            '--dze-nav-left': `${navSide}px`,
            '--dze-nav-right': `${navRight}px`,
            '--dze-media-top': `${mediaTop}px`,
            '--dze-media-width': `${mediaWidth}px`,
            '--dze-media-height': `${imageHeight}px`,
            '--dze-caption-top': `${captionTop}px`,
            '--dze-intro-top': `${introTop}px`,
            '--dze-intro-opacity': introOpacity.toFixed(3),
            '--dze-menu-height': `200px`,
            '--dze-menu-top': `125px`,
            '--dze-menu-out-left': `820px`,
            '--dze-menu-font-size': `20px`,
            '--dze-menu-gap-in': `80px`,
            '--dze-menu-gap-out': `80px`,
            '--dze-utility-right': `${utilityRight}px`,
            '--dze-utility-gap': `40px`,
            '--dze-utility-icon': `40px`
          });

          if (pendingMenu && progress >= 0.96) {
            const menu = pendingMenu;
            pendingMenu = null;
            setMenu(menu);
          } else if (!pendingMenu && progress < 0.88 && activeMenu && !isCompact) {
            setMenu(null);
          }
        };

        const queue = () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(update);
        };

        const getOpenNavSize = (width) => {
          if (width > 1920) return 240;
          if (width > 1440) return 160;
          if (width >= 960) return 120;
          if (width <= 749) return 44; // 移动端大字版固定为 44px
          return Math.max(84, Math.min(120, width * 0.17));
        };

        $menuTriggers.on('click', function(event) {
          event.preventDefault();
          if (event.originalEvent && event.originalEvent.detail > 0) {
            this.blur();
          }
          const menu = $(this).attr('data-dze-menu-trigger');

          if (activeMenu === menu) {
            pendingMenu = null;
            setMenu(null);
            return;
          }

          const rectTop = $section[0].getBoundingClientRect().top;
          const distance = Math.max($(window).height() * 0.82, 1);
          const rawProgress = isCompact ? 1 : Math.min(Math.max(-rectTop / distance, 0), 1);
          const currentProgress = motionQuery.matches ? 1 : rawProgress;
          
          if (!isCompact && !motionQuery.matches && currentProgress < 0.88) {
            pendingMenu = menu;
            setMenu(null);
            const sectionTop = window.scrollY + rectTop;
            window.scrollTo({ top: sectionTop + distance, behavior: 'smooth' });
            return;
          }

          pendingMenu = null;
          setMenu(menu);
        });

        // Cart Drawer Logic
        const $cartTriggers = $('[data-dze-cart-trigger]');
        const $cartClose = $('[data-dze-cart-close]');
        const $cartDrawer = $('#cart-drawer');
        const $cartOverlay = $('.dze-cart-drawer-overlay');
        const $cartContent = $cartDrawer.find('.dze-cart-drawer__content');
        const $body = $('body');
        const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        let cartItems = [];

        const renderCart = () => {
          const itemCount = cartItems.reduce((total, item) => total + item.quantity, 0);
          $cartDrawer.find('.dze-cart-drawer__item-count').text(`Your cart - ${itemCount} ${itemCount === 1 ? 'item' : 'items'}`);
          $cartContent.empty().append($('<h2 class="dze-cart-drawer__heading">').text('Your cart'));

          if (!cartItems.length) {
            $cartContent
              .append($('<p class="dze-cart-drawer__empty-text">').text('Your cart is currently empty.'))
              .append($(`<a class="dze-cart-drawer__continue" data-dze-cart-close href="${shopRoot}collections/accessories">`).text('Continue shopping →'));
            return;
          }

          const $items = $('<div class="dze-cart-drawer__items">');
          cartItems.forEach((item) => {
            const $item = $('<article class="dze-cart-drawer__item">');
            $('<img class="dze-cart-drawer__item-image" width="120" height="120">').attr({ src: item.image || '', alt: '' }).appendTo($item);
            const $copy = $('<div class="dze-cart-drawer__item-copy">').appendTo($item);
            $('<div class="dze-cart-drawer__item-title">').text(item.title).appendTo($copy);
            $('<div class="dze-cart-drawer__item-detail">').text(window.Shopify && Shopify.formatMoney ? Shopify.formatMoney(item.final_price) : `€${(item.final_price / 100).toFixed(2)}`).appendTo($copy);
            const $quantity = $('<div class="dze-cart-drawer__quantity" role="group">')
              .attr('aria-label', `Quantity for ${item.title}`).appendTo($copy);
            const $decrease = $('<button type="button" data-dze-cart-step="-1">')
              .attr({ 'data-dze-cart-key': item.key, 'aria-label': item.quantity === 1 ? `Remove ${item.title} from cart` : `Decrease quantity of ${item.title}` })
              .appendTo($quantity);
            if (item.quantity === 1) {
              $decrease.html('<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M9 6V4h6v2M5 6l1 14h12l1-14M10 10v6M14 10v6"/></svg>');
            } else {
              $decrease.append($('<span aria-hidden="true">').text('−'));
            }
            $('<span class="dze-cart-drawer__quantity-value">').attr('aria-label', `Quantity: ${item.quantity}`).text(item.quantity).appendTo($quantity);
            $('<button type="button" data-dze-cart-step="1">')
              .attr({ 'data-dze-cart-key': item.key, 'aria-label': `Increase quantity of ${item.title}` })
              .append($('<span aria-hidden="true">').text('+')).appendTo($quantity);
            $items.append($item);
          });
          $cartContent.append($items);

          const subtotal = cartItems.reduce((total, item) => total + item.final_line_price, 0);
          $cartContent.append(
            $('<div class="dze-cart-drawer__subtotal">')
              .append($('<span>').text('Subtotal'))
              .append($('<span>').text(window.Shopify && Shopify.formatMoney ? Shopify.formatMoney(subtotal) : `€${(subtotal / 100).toFixed(2)}`))
          );
          $cartContent.append($(`<a class="dze-cart-drawer__continue" data-dze-cart-close href="${shopRoot}collections/accessories">`).text('Continue shopping →'));
          $cartContent.append($(`<a class="dze-cart-drawer__checkout" href="${shopRoot}checkout">`).text('Check out →'));
        };

        const openCart = (e) => {
          if (e) e.preventDefault();
          $cartDrawer.addClass('is-active');
          $cartDrawer.attr('aria-hidden', 'false');
          $cartOverlay.addClass('is-active');
          $body.css('overflow', 'hidden'); // Prevent background scrolling
        };

        const closeCart = (e) => {
          if (e) e.preventDefault();
          $cartDrawer.removeClass('is-active');
          $cartDrawer.attr('aria-hidden', 'true');
          $cartOverlay.removeClass('is-active');
          $body.css('overflow', '');
        };

        $cartTriggers.on('click', openCart);
        $cartClose.on('click', closeCart);

        const refreshCart = () => fetch(`${shopRoot}cart.js`, { headers: { Accept: 'application/json' } })
          .then((response) => response.json())
          .then((cart) => { cartItems = cart.items || []; renderCart(); return cart; });

        $(document).on('click', '[data-dze-add-to-cart]', async function(e) {
          e.preventDefault();
          const $button = $(this);
          const $form = $button.closest('form[action*="/cart/add"]');
          let variantId = $form.find('[name="id"]').val();
          const quantity = Math.max(1, Number($form.find('[name="quantity"]').val()) || 1);
          try {
            if (!variantId) {
              const handle = $button.attr('data-product-id');
              const productResponse = await fetch(`${shopRoot}products/${handle}.js`);
              if (!productResponse.ok) throw new Error('Product is not configured in Shopify');
              const product = await productResponse.json();
              variantId = product.variants.find((variant) => variant.available)?.id;
            }
            if (!variantId) throw new Error('No available variant');
            const response = await fetch(`${shopRoot}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] })
            });
            if (!response.ok) throw new Error((await response.json()).description || 'Unable to add item');
            await refreshCart();
            openCart();
          } catch (error) {
            window.alert(error.message);
          }
        });

        let cartQuantityPending = false;
        $(document).on('click', '[data-dze-cart-step]', async function() {
          if (cartQuantityPending) return;
          const key = $(this).attr('data-dze-cart-key');
          const step = Number($(this).attr('data-dze-cart-step'));
          const item = cartItems.find((entry) => entry.key === key);
          if (!item || ![-1, 1].includes(step)) return;
          const quantity = Math.max(0, item.quantity + step);
          cartQuantityPending = true;
          $cartContent.find('.dze-cart-drawer__error').remove();
          $cartContent.attr('aria-busy', 'true').find('[data-dze-cart-step]').prop('disabled', true);
          try {
            const response = await fetch(`${shopRoot}cart/change.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: key, quantity })
            });
            const cart = await response.json();
            if (!response.ok) throw new Error(cart.description || cart.message || 'Unable to update quantity. Please try again.');
            if (!Array.isArray(cart.items)) throw new Error('Unable to update quantity. Please try again.');
            cartItems = cart.items;
            renderCart();
            const $nextFocus = $cartContent.find('[data-dze-cart-step]').filter(function() {
              return $(this).attr('data-dze-cart-key') === key && Number($(this).attr('data-dze-cart-step')) === step;
            }).first();
            ($nextFocus[0] || $cartContent.find('[data-dze-cart-step], [data-dze-cart-close]')[0])?.focus({ preventScroll: true });
          } catch (error) {
            $('<p class="dze-cart-drawer__error" role="alert">').text(error.message).prependTo($cartContent);
          } finally {
            cartQuantityPending = false;
            $cartContent.removeAttr('aria-busy').find('[data-dze-cart-step]').prop('disabled', false);
          }
        });

        refreshCart();
        
        // Account Popover Logic
        const $accountTriggers = $('[data-dze-account-trigger]');
        const $accountClose = $('[data-dze-account-close]');
        const $accountPopover = $('#accountPopover');

        const toggleAccount = (e) => {
          if (e) e.preventDefault();
          $accountPopover.toggleClass('is-active');
        };

        const closeAccount = (e) => {
          if (e) e.preventDefault();
          $accountPopover.removeClass('is-active');
        };

        $accountTriggers.on('click', toggleAccount);
        $accountClose.on('click', closeAccount);

        // Close when clicking outside
        $(document).on('click', function(e) {
          if ($accountPopover.hasClass('is-active')) {
            if (!$(e.target).closest('#accountPopover').length && !$(e.target).closest('[data-dze-account-trigger]').length) {
              closeAccount();
            }
          }
        });

        $(window).on('scroll resize', queue);
        motionQuery.addEventListener('change', queue);
        setMenu(null);
        update();

        // Intersection Observer for strict scroll-based lazy loading
        if ('IntersectionObserver' in window) {
          const imageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                const img = entry.target;
                const realSrc = img.getAttribute('data-src');
                
                if (realSrc) {
                  // Only attach load event when we actually set the src
                  $(img).on('load', function() {
                    $(this).addClass('is-loaded');
                  });
                  img.src = realSrc;
                  img.removeAttribute('data-src');
                }
                observer.unobserve(img);
              }
            });
          }, {
            root: null,
            rootMargin: '200px 0px', // Load images when they are 200px from viewport
            threshold: 0.01
          });

          $('img.lazy-image').each(function() {
            imageObserver.observe(this);
          });
        } else {
          // Fallback for older browsers
          $('img.lazy-image').each(function() {
            const realSrc = $(this).attr('data-src');
            if (realSrc) {
              this.src = realSrc;
              $(this).addClass('is-loaded');
            }
          });
        }
      });

      (function initProductRecommendations() {
        document.querySelectorAll('[data-dze-product-recommendations]').forEach(function(section) {
          const url = section.getAttribute('data-recommendations-url');
          const sectionId = section.getAttribute('data-section-id');
          if (!url || !sectionId || section.dataset.recommendationsLoaded === 'true') return;
          section.dataset.recommendationsLoaded = 'true';

          fetch(url, { headers: { Accept: 'text/html' } })
            .then(function(response) {
              if (!response.ok) throw new Error('Unable to load product recommendations');
              return response.text();
            })
            .then(function(html) {
              const documentFragment = new DOMParser().parseFromString(html, 'text/html');
              const replacement = documentFragment.querySelector('[data-dze-product-recommendations][data-section-id="' + CSS.escape(sectionId) + '"]');
              if (!replacement) return;
              replacement.dataset.recommendationsLoaded = 'true';
              section.replaceWith(replacement);
            })
            .catch(function() {
              section.dataset.recommendationsError = 'true';
            });
        });
      })();

      (function initGlobalSearch() {
        const overlay = document.querySelector('[data-dze-search-overlay]');
        if (!overlay) return;
        const input = overlay.querySelector('input[type="search"]');
        const open = () => { overlay.hidden = false; document.body.classList.add('dze-overlay-open'); window.setTimeout(() => input && input.focus(), 20); };
        const close = () => { overlay.hidden = true; document.body.classList.remove('dze-overlay-open'); };
        document.addEventListener('click', (event) => {
          if (event.target.closest('[data-dze-search-trigger]')) { event.preventDefault(); open(); }
          if (event.target.closest('[data-dze-search-close]')) { event.preventDefault(); close(); }
        });
        document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !overlay.hidden) close(); });
      })();

      (function initNewsletterForms() {
        document.querySelectorAll('form.dze-footer__newsletter').forEach((form) => {
          if (form.dataset.dzeNewsletterReady === 'true') return;
          form.dataset.dzeNewsletterReady = 'true';

          const input = form.querySelector('[data-dze-newsletter-email]');
          const submit = form.querySelector('[data-dze-newsletter-submit]');
          const result = form.querySelector('[data-dze-newsletter-result]');
          if (!input || !submit || !result) return;

          const defaultLabel = submit.dataset.defaultLabel || submit.textContent.trim();
          const showSuccess = () => {
            input.value = '';
            submit.textContent = 'Thank You';
            result.textContent = 'Thank You';
            result.dataset.success = 'true';
          };

          if (result.dataset.success === 'true') {
            showSuccess();
            const cleanUrl = new URL(window.location.href);
            cleanUrl.searchParams.delete('customer_posted');
            cleanUrl.hash = '';
            window.history.replaceState({}, '', cleanUrl.pathname + cleanUrl.search);
          }

          input.addEventListener('input', () => {
            if (submit.textContent !== defaultLabel) submit.textContent = defaultLabel;
          });

          form.addEventListener('submit', async (event) => {
            event.preventDefault();
            if (!form.reportValidity()) return;

            submit.disabled = true;
            try {
              const response = await fetch(form.action, {
                method: 'POST',
                body: new FormData(form),
                credentials: 'same-origin',
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
              });
              const responseHtml = await response.text();
              const responseDocument = new DOMParser().parseFromString(responseHtml, 'text/html');
              const returnedResult = responseDocument.querySelector('form.dze-footer__newsletter [data-dze-newsletter-result]');
              const responseUrl = new URL(response.url, window.location.origin);
              const posted = responseUrl.searchParams.get('customer_posted') === 'true' || returnedResult?.dataset.success === 'true';
              if (!response.ok || !posted) throw new Error('Newsletter subscription failed');
              showSuccess();
            } catch (error) {
              submit.textContent = 'Try Again';
              result.textContent = 'Please try again';
              result.dataset.success = 'false';
            } finally {
              submit.disabled = false;
            }
          });
        });
      })();

      // Keep the static prototype aligned with the v5 Figma information architecture.
      $(function() {
        // Shopify templates already contain the final routes and assets. The code
        // below is retained only so the standalone HTML previews keep working.
        if (window.Shopify) return;
        const page = window.location.pathname.split('/').pop() || 'index.html';
        const routes = {
          'Guānyīn Project': 'guanyin-project.html',
          'Artists': 'artists.html',
          'Sound Map': 'https://soundmap.dzelabs.com/',
          'Label': 'albums.html',
          'Programs': 'programs.html'
        };

        $('.dze-index__menu-link').each(function() {
          const label = $(this).text().trim();
          if (routes[label]) $(this).attr('href', routes[label]);
        });
        $('.dze-index__menu-sublink').each(function() {
          const label = $(this).text().trim().toLowerCase();
          if (label.includes('guān yīn')) $(this).attr('href', 'guanyin.html');
          if (label === 'mò' || label.includes('mò(5.5mm)')) $(this).attr('href', 'mo.html');
        });
        $('.dze-footer a').each(function() {
          const label = $(this).text().replace(/\s+/g, ' ').trim();
          if (label.startsWith('Sound Map Submission')) $(this).attr('href', 'services.html');
          if (label === 'About') $(this).attr('href', 'about.html');
        });
        $('.dze-cart-drawer__continue').attr('href', 'accessories.html');

        if (page === 'index.html') {
          $('.dze-index__image').attr('data-src', 'figma-v5/index-portrait.jpg');
          $('.dze-content__full').eq(0).find('img').attr('data-src', 'figma-v5/index-recording.jpg');
          $('.dze-content__full').eq(0).find('.dze-content__image-caption').html('<div class="dze-content__image-caption-left">Francisco López test recordings</div><div class="dze-content__image-caption-center">West Coast of Ireland</div><div class="dze-content__image-caption-right">A multi-sensor acoustic experiment using xī, guān yīn and mò.</div>');
          $('.dze-content__full').eq(1).find('img').attr('data-src', 'figma-v5/index-microphone.jpg');
          $('.dze-content__grid-item').each(function() {
            const label = $(this).find('.dze-content__grid-header').text().trim();
            if (label === 'Sound Map') $(this).attr('href', 'https://soundmap.dzelabs.com/').find('img').attr('data-src', 'figma-v5/sound-map-preview.jpg');
            if (label === 'Programs') $(this).attr('href', 'programs.html').find('img').attr('data-src', 'figma-v5/program-interview.jpg');
          });
          $('.dze-content__grid-3').last().find('.dze-content__grid-item').attr('href', 'programs.html');
          const $labelBlock = $('.dze-content__grid-header').filter(function() { return $(this).text().trim() === 'dze.Label'; }).closest('.dze-content__full');
          if ($labelBlock.length && !$labelBlock.parent().is('a')) $labelBlock.wrap('<a class="v5-block-link" href="albums.html"></a>');
        }

        if (page === 'artists.html') {
          const artists = [
            ['Adam Świtała', 'artist-adam.jpg'], ['Cedrik Fermont', 'artist-cedrik.jpg'],
            ['Dickson Dee', 'artist-dickson.jpg'], ['Francisco López', 'artist-francisco.jpg'],
            ['Grzegorz Bojanek', 'artist-grzegorz.jpg'], ['Jacaszek', 'artist-jacaszek.jpg'],
            ['Miaoyuan LONG', 'artist-miaoyuan.jpg'], ['Tomasz Guiddo', 'artist-tomasz.jpg'],
            ['Zen Lu', 'artist-zen.jpg']
          ];
          $('.dze-collection').html(`
            <figure class="v5-hero"><img src="figma-v5/artist-francisco.jpg" alt="Francisco López"></figure>
            <div class="v5-intro"><h1>Francisco López</h1><p>Francisco López is internationally recognized as one of the main figures in experimental music and audio art. For more than forty years, his field recordings, installations and performances have developed a deeply personal way of listening to the world.</p><p><a href="artist-detail.html">VIEW MORE →</a></p></div>
            <h2 class="v5-section__title">Artists</h2>
            <div class="v5-grid">${artists.map(([name, image]) => `<a class="v5-card" href="${name === 'Francisco López' ? 'artist-detail.html' : '#'}"><img src="figma-v5/${image}" alt="${name}"><h2>${name}</h2></a>`).join('')}</div>
          `);
        }

        if (page === 'albums.html') {
          document.title = 'dze.labs Label - dze.labs - Official Website';
          $('.dze-collection').html(`
            <figure class="v5-hero"><img src="figma-v5/label-cover.jpg" alt="dze.labs Label"></figure>
            <div class="v5-intro"><h1>dze.labs Label</h1><p>dze.labs Label is a curated sonic publishing program dedicated to discovering and transmitting meaningful sound experiences from around the world.</p><p>Through the Sound Map, selected field recordings are reviewed and transformed into published sonic works chosen for artistic expression, environmental sensitivity, and their relationship between sound, place, and perception.</p><p>Resonance, Transmitted.</p></div>
            <div class="v5-split"><img src="figma-assets/Above the Sound of Water-01.png" alt="Above the Sound of Water"><div class="v5-copy"><div class="v5-kicker">Label.Issue 001</div><h2 class="v5-section__title">Above the Sound of Water</h2><p>Artist: Zen Lu<br>dze.labs Label. 2026</p><p>Seven field recordings from Kyoto, Kobe and Zhijiang, captured with Sound Devices MixPre-6 II, dze. Geophone and LOM microphones.</p><p><a href="album-detail.html">VIEW RELEASE →</a></p></div></div>
          `);
        }

        if (page === 'product.html') {
          const model = new URLSearchParams(window.location.search).get('model');
          const products = {
            guanyin: {
              title: 'dze. Microphone 10mm (guān yīn)', price: 'Euro €200.00', token: '(guān yīn)',
              hero: 'mic10-hero.jpg', wide: 'mic10-wide.jpg', recording: 'mic10-recording.jpg',
              description: 'guān yīn (10mm) is an omnidirectional electret condenser microphone with phantom power support. Renowned for its ultra-compact size, ultra-low self-noise and high sensitivity, it delivers an ultra-wide frequency response extending to ultrasonic frequencies below 80kHz. Ideal for natural sound capture, field recording and covert audio pickup scenarios.',
              specs: [['Directivity','Omni-directional'],['Maximum input SPL','~122 dB'],['Dynamic range','108 dB'],['Signal to noise ratio (SNR)','80 dB'],['Self noise','~14 dBA'],['Sensitivity','-28 dB (± 3.0 dB @ 1 KHz)'],['Impedance','30–50 ohm'],['Operating voltage','48V phantom power IEC61938'],['Cable','1.5 meters, TPU 2.6 mm cable'],['Output','Balanced XLR-3M, black Neutrik gold-plated connector'],['Dimensions','29 mm length × 13 mm diameter'],['Weight','135 g']],
              caption: 'Records delicate environmental soundscapes.', recordingCopy: 'Prayer Wheel Recording @ Kangding Vajra Temple. 11 July 2026. Recorded by Zen Lu with Sound Devices MixPre-6 II.'
            },
            mo: {
              title: 'dze. Microphone 5.5mm (mò)', price: 'Euro €215.00', token: '(mò)',
              hero: 'mic5-hero.jpg', wide: 'mic5-wide.jpg', recording: 'mic5-recording.jpg',
              description: 'Mò (5.5mm) is a miniature omnidirectional electret condenser microphone with ultra-compact size, low self-noise and high sensitivity. Portable and easy to conceal, it captures ambient sound, subtle air vibrations and ultrasonic detail for field recording, soundscape creation and acoustic research.',
              specs: [['Directivity','Omni-directional'],['Maximum input SPL','~115 dB'],['Dynamic range','95 dB'],['Signal to noise ratio (SNR)','74 dB'],['Self noise','~20 dBA'],['Sensitivity','-32 dB (± 3.0 dB @ 1 KHz)'],['Impedance','30–50 ohm'],['Operating voltage','48V phantom power IEC61938'],['Cable','1.5 meters, TPU 2.0 mm cable'],['Output','Balanced XLR-3M, black Neutrik gold-plated connector'],['Dimensions','19 mm length × 6.8 mm diameter'],['Weight','82 g']],
              caption: 'Captures sounds at the edge of silence.', recordingCopy: 'Recording by Zen Lu on YanHan Mountain, OCT-LOFT, Shenzhen, using dze. Microphone 5.5mm (mò) and Sound Devices MixPre-6 II.'
            }
          };
          const product = products[model];
          if (product) {
            document.title = `${product.title} - dze.labs - Official Website`;
            $('.dze-product__title').text(product.title);
            $('.dze-product__price').text(product.price);
            $('.dze-product__description').text(product.description);
            $('.dze-product__specs').html(product.specs.map(([key, value]) => `<div class="dze-product__spec"><span>${key}:</span><span>${value}</span></div>`).join(''));
            $('.dze-product__hero img').attr({src: `figma-v5/${product.hero}`, alt: product.title}).removeAttr('data-src');
            $('.dze-product__wide').eq(0).find('img').attr({src: `figma-v5/${product.wide}`, alt: product.title}).removeAttr('data-src');
            $('.dze-product__wide').eq(1).find('img').attr({src: `figma-v5/${product.recording}`, alt: `${product.title} recording`}).removeAttr('data-src');
            $('.dze-product__wide').eq(2).find('img').attr({src: `figma-v5/${product.wide}`, alt: `${product.title} set`}).removeAttr('data-src');
            $('.dze-product__recording-media').html(`<img src="figma-v5/${product.recording}" alt="${product.title} recording">`);
            $('.dze-product__recording-label').html(`${product.title}<br>Recording`);
            $('.dze-product__recording-copy').text(product.recordingCopy);
            $('.dze-product__meta').each(function() { $(this).html(`<span>${product.title}</span><span>${product.token}</span><span>${product.caption}</span>`); });
            $('.dze-product__details img').each(function(index) {
              const images = [product.hero, product.wide, product.recording];
              $(this).attr({src: `figma-v5/${images[index]}`, alt: product.title}).removeAttr('data-src');
            });
            $('.dze-product__paired img').each(function(index) {
              const images = [product.wide, product.hero, product.recording, product.wide];
              $(this).attr({src: `figma-v5/${images[index % images.length]}`, alt: product.title}).removeAttr('data-src');
            });
            const accessory = model === 'guanyin'
              ? [['guān yīn (XLR) cable', '€50.00'], ['Specialized fuzzy windscreen', '€5.00']]
              : [['mò (XLR) cable', '€50.00'], ['mò microphone clip', '€5.00']];
            $('.dze-product__catalog').not('.dze-product__catalog--related').html(`<h2 class="dze-product__catalog-title">accessories</h2><div class="dze-product__catalog-grid dze-product__catalog-grid--two"><figure><img src="figma-v5/${product.wide}" alt="${accessory[0][0]}"></figure><figure><img src="figma-v5/${product.hero}" alt="${accessory[1][0]}"></figure></div><div class="dze-product__catalog-copy dze-product__catalog-copy--two">${accessory.map(([name, price]) => `<div class="dze-product__card-meta"><span>${name}</span><span>${price}</span><span>+</span></div>`).join('')}</div>`);
            const related = model === 'guanyin'
              ? [['dze. Geophone (xī)', '€180.00', 'product.html', 'index-geophone.jpg'], ['dze. Microphone 5.5mm (mò)', '€215.00', 'mo.html', 'mic5-hero.jpg']]
              : [['dze. Geophone (xī)', '€180.00', 'product.html', 'index-geophone.jpg'], ['dze. Microphone 10mm (guān yīn)', '€200.00', 'guanyin.html', 'mic10-hero.jpg']];
            $('.dze-product__catalog--related').html(`<h2 class="dze-product__catalog-title">related</h2><div class="dze-product__catalog-grid dze-product__catalog-grid--two">${related.map(([name, price, href, image]) => `<a href="${href}"><figure><img src="figma-v5/${image}" alt="${name}"></figure></a>`).join('')}</div><div class="dze-product__catalog-copy dze-product__catalog-copy--two">${related.map(([name, price]) => `<div class="dze-product__card-meta"><span>${name}</span><span>${price}</span><span>+</span></div>`).join('')}</div>`);
          }
        }
      });

      $(function() {
        $('.dze-slideshow-wrapper').each(function() {
          const $wrapper = $(this);
          const $track = $wrapper.find('.dze-slideshow__track');
          const $slides = $track.children();
          const $dotsContainer = $wrapper.find('.dze-product__dots');
          
          if (!$track.length || !$slides.length) return;

          let currentIndex = 0;
          const totalSlides = $slides.length;

          // Dynamically generate dots based on the number of slides
          if ($dotsContainer.length) {
            $dotsContainer.empty();
            for (let i = 0; i < totalSlides; i++) {
              $dotsContainer.append(`<span class="${i === 0 ? 'is-active' : ''}"></span>`);
            }
          }
          
          const $dots = $dotsContainer.find('span');

          function updateSlide(index) {
            if (index < 0) index = totalSlides - 1;
            if (index >= totalSlides) index = 0;
            
            // Pause all videos in this slideshow before sliding
            $slides.each(function() {
              if ($(this).is('video')) {
                $(this)[0].pause();
              }
            });

            currentIndex = index;
            $track.css('transform', `translateX(-${currentIndex * 100}%)`);
            
            if ($dots.length) {
              $dots.removeClass('is-active');
              $dots.eq(currentIndex).addClass('is-active');
            }
          }

          $dots.on('click', function() {
            updateSlide($(this).index());
          });

          // Allow clicking video to play/pause (since controls might be small or hard to hit)
          $slides.filter('video').on('click', function() {
            if (this.paused) {
              this.play();
            } else {
              this.pause();
            }
          });
        });
      });
